var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1024_1439",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.90918,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1024_1439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.57617 14.5C5.20951 14.5 4.89562 14.3694 4.63451 14.1083C4.37339 13.8472 4.24284 13.5333 4.24284 13.1667V4.5H3.57617V3.16667H6.9095V2.5H10.9095V3.16667H14.2428V4.5H13.5762V13.1667C13.5762 13.5333 13.4456 13.8472 13.1845 14.1083C12.9234 14.3694 12.6095 14.5 12.2428 14.5H5.57617ZM12.2428 4.5H5.57617V13.1667H12.2428V4.5ZM6.9095 11.8333H8.24284V5.83333H6.9095V11.8333ZM9.57617 11.8333H10.9095V5.83333H9.57617V11.8333Z",
    fill: "#F0F0F0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.cf5987c4abf2bd81607c1ef7bb0a0bfb.svg";
export { ForwardRef as ReactComponent };